import { Component } from '@angular/core'
import { FieldType } from '@ngx-formly/core'

@Component({
  selector: 'basin-formly-input-number',
  templateUrl: './formly-input-number.component.html',
  styleUrls: [],
})
export class FormlyInputNumberComponent extends FieldType {}
